// import {ApiLogin} from '../../api/auth/api-login';
import actionCreatorFactory from 'typescript-fsa';
import {
  Position, Address, GPSStatus, MapAreaPosition, RouteInfo,
} from '../../type/map/map.type';
import { AddressSearch } from '../../type/map/address-search.type';
import { ApiMap } from '../root.type';

const ActionCreator = actionCreatorFactory('map');

export const MapActions = {
  api: {
    getLocationImg: ActionCreator<{
      param: ApiMap.GetLocationImg.Param;
      callback:(url: string | null) => void;
        }>('api/get/location/img'),
    geocoder: ActionCreator<{
      isPost?: boolean;
      isRegist?: boolean;
      param: ApiMap.GeoCoder.Param;
      callback?:(url: { position: Position, address: string; }) => void;
        }>('/api/geocoder'),
    addressSearch: ActionCreator<{
      param: ApiMap.AddressSearch.Param;
      callback:(address: AddressSearch) => void;
        }>('api/address/search'),
  },
  gps: {
    start: ActionCreator<{ onFirstLoaded?: boolean, callback?:(v:Position) => void, onError?: () => void, }>('gps/start'),
    stop: ActionCreator('gps/stop'),
    setId: ActionCreator<number | null>('gps/set/id'),
  },
  setMap: ActionCreator<globalThis.google.maps.Map | null>('set/map'),
  loading: ActionCreator<boolean>('loading'),
  setMapAreaPosition: ActionCreator<MapAreaPosition | null>('set/map/area/position'),
  setRouteMapAreaPosition: ActionCreator<MapAreaPosition | null>('set/route/map/area/position'),
  setGpsStatus: ActionCreator<GPSStatus>('set/gps/status'),
  // setDestinationPos: ActionCreator<Position | null>('set/destination/pos'),
  setRouteSearchName: ActionCreator<string>('set/route/search/name'),
  setRouteInfo: ActionCreator<RouteInfo | null>('set/route/info'),
  setFlickLoad: ActionCreator<boolean>('set/flick/load'),
  setHumanPos: ActionCreator<Position | null>('set/human/pos'),
  setZoomLevel: ActionCreator<number | null>('set/zoom/level'),
  setRouteZoomLevel: ActionCreator<number | null>('set/route/zoom/level'),
  setCenterPos: ActionCreator<Position | null>('set/center/pos'),
  setSearchPos: ActionCreator<Position | null>('set/search/pos'),
  setSearchAddress: ActionCreator<Address | null>('set/search/address'),
  setAreaBtnDisabled: ActionCreator<boolean>('set/area/btm/disabled'),
  setRouteAreaBtnDisabled: ActionCreator<boolean>('set/route/area/btm/disabled'),
  resetState: ActionCreator('reset/state'),
};
